import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import {
  URL_QUESTIONARIO,
  URL_QUESTIONARIO_RESPOSTA,
  URL_QUESTIONARIO_REFAZER,
} from '@modules/professional-waitlist/constants/URL'

const ERRO_INESPERADO = 'Erro inesperado. Tente novamente mais tarde.'

/**
 * Questionário de onboarding da lista de espera (spec-001-chat-onboarding-lista-espera,
 * T010). Envelope HTTP-200-always (`contracts/questionario-estado.json`): o `status` do
 * CORPO decide o significado — 409 (revisão desatualizada, AC-2.4), 403 (sem a flag), 422
 * (resposta vazia) e 500 (falha ao gravar, AC-2.3) voltam como RETORNO normal desta classe,
 * nunca como exceção lançada. Quem decide o que fazer com cada status é o store
 * (`store/actions.js`) — esta classe só fala com a rede.
 */
class APIListaEspera extends APITemplate {
  // GET /questionario — estado corrente. Só leitura: nunca cria a linha por ser lida
  // (o backend já garante isso — `usecase_estado.ler_estado`).
  async carregar() {
    const r = await con.get(URL_QUESTIONARIO)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  // PUT /questionario/resposta — grava a resposta do campo corrente ANTES de avançar
  // (AC-2.1). `revisaoEsperada` é o cinto de segurança de duas abas (AC-2.4): divergente
  // do lado do servidor, a rota responde 409 em vez de sobrescrever.
  //
  // `valorComplementar` é o texto livre da pergunta de SELEÇÃO (`cargo`) quando a opção
  // escolhida o abre ('Outros'). Viaja no MESMO PUT da opção — o backend grava as duas
  // colunas na mesma instrução. Só entra no corpo quando existe: mandar `null` numa
  // pergunta de texto é ruído, e o backend responde 422 para complemento onde não cabe.
  async responder({ campo, valor, revisaoEsperada, valorComplementar }) {
    const corpo = {
      campo: campo,
      valor: valor,
      revisao_esperada: revisaoEsperada,
    }
    if (valorComplementar) corpo.valor_complementar = valorComplementar

    const r = await con.put(URL_QUESTIONARIO_RESPOSTA, corpo)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  // POST /questionario/refazer — não-destrutivo por construção (AC-4.1/4.2/4.4): o
  // backend preserva todas as respostas e a posição já atribuída, só volta o
  // `campo_atual` para o começo.
  async refazer() {
    const r = await con.post(URL_QUESTIONARIO_REFAZER, {})
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }
}

// Singleton no padrão do projeto: instância nomeada + export explícito.
const apiListaEspera = new APIListaEspera()

export { apiListaEspera }
